export const PROFILE_COMPLETION_ITEMS = [
  { id: 'profile_image', label: 'Photo de profil' },
  { id: 'business_name', label: 'Nom commercial' },
  { id: 'bio', label: 'Bio courte' },
  { id: 'description', label: 'Description détaillée' },
  { id: 'city', label: 'Ville' },
  { id: 'active_product', label: 'Au moins une création active' },
];

const hasText = (value) => typeof value === 'string' && value.trim() !== '';

export const computeProfileCompletion = ({
  profileImage,
  creatorData = {},
  activeProductsCount = 0,
}) => {
  const completionById = {
    profile_image: Boolean(profileImage),
    business_name: hasText(creatorData.businessName),
    bio: hasText(creatorData.bio),
    description: hasText(creatorData.description),
    city: hasText(creatorData.city),
    active_product: activeProductsCount > 0,
  };

  const items = PROFILE_COMPLETION_ITEMS.map((item) => ({
    ...item,
    completed: Boolean(completionById[item.id]),
  }));

  const completedCount = items.filter((item) => item.completed).length;
  const totalCount = items.length;

  return {
    percent: totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0,
    completed_count: completedCount,
    total_count: totalCount,
    is_complete: completedCount === totalCount,
    items,
  };
};

export default computeProfileCompletion;
